import {Link} from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import './NotFound.css';

const {FiArrowLeft,FiCompass} = FiIcons;

function NotFound() {
  return (
    <main className="not-found-page">
      <div className="container">
        <section className="not-found-card" aria-labelledby="not-found-title">
          <div className="not-found-icon">
            <SafeIcon icon={FiCompass} />
          </div>
          <span className="content-label">Error 404</span>
          <h1 id="not-found-title">Page not found</h1>
          <p>
            We could not find the page you were looking for. It may have moved,
            or the link may be outdated.
          </p>
          <Link className="not-found-home-link" to="/">
            <SafeIcon icon={FiArrowLeft} />
            Back to home
          </Link>
        </section>
      </div>
    </main>
  );
}

export default NotFound;